import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leandro',
  templateUrl: './leandro.component.html',
  styleUrls: ['./leandro.component.css']
})
export class LeandroComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
